/**
 * @generated SignedSource<<f4727137d8afc58adedd0d014ff90f13>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type NativeCollabProviderQuery_user_AtlassianUser_photos_AtlassianUserPhoto =
  {
    __typename?: "AtlassianUserPhoto";
    value: string | null;
    isPrimary: boolean | null;
  };
export type NativeCollabProviderQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    permissionType: SitePermissionType | null;
  };
export type NativeCollabProviderQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  displayName: string | null;
  photos: Array<NativeCollabProviderQuery_user_AtlassianUser_photos_AtlassianUserPhoto | null> | null;
  confluence?: NativeCollabProviderQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type NativeCollabProviderQuery_Query = {
  __typename?: "Query";
  user: NativeCollabProviderQuery_user_AtlassianUser | null;
};
export type NativeCollabProviderQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  shouldIncludePermissionType?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;
export type NativeCollabProviderQuery = NativeCollabProviderQuery_Query;
